import { useEffect, useState } from "react";
import styled from "styled-components";

const Section = styled.div`
  margin-bottom: 120px;


  @media (max-width: 426px){
    margin-bottom: 80px;
  }

  & > p:first-child{
    font-size: 20px;
    font-weight : bold;
    margin-bottom: 16px;
    position: relative;

    &:before{
      content:"";
      display:block;
      width:64px; 
      height:4px; 
      margin-bottom:8px;
      background:#BD1236;
    }

    @media (max-width: 426px){
      font-size : 16px;
      margin-bottom : 8px;
    }
  }
  
  & > p:nth-of-type(2){
    font-size: 16px;
    color: #595959;
    margin-bottom: 24px;

    @media (max-width: 426px){
      font-size : 14px;
      margin-bottom : 12px;
      line-height : 1.3;
    }
  }

  & > div{
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    grid-template-areas: "video cards";

    @media (max-width: 426px){
      grid-template-columns: 1fr;
      grid-template-areas:
      "video"
      "cards";
    }


  }

  & > div > div:first-child{
    max-height: 330px;
    display: grid;
    grid-auto-rows: minmax(161px, auto);
    grid-template-rows: 161px;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    overflow-x: hidden;
    box-sizing: content-box;
    padding-right: 2px;
    grid-area: cards;
    

    @media (max-width: 426px){
      max-height: 188px;
      grid-area: cards;
      grid-template-columns: 1fr 1fr;
      gap: 8px;
      grid-template-rows: 90px;
      grid-auto-rows: 90px;
    }
  }

  & > div > div:first-child::-webkit-scrollbar{
    width : 10px;
  }

  & > div > div:first-child::-webkit-scrollbar-thumb{
    background: #bd1236;
    border-radius: 8px;
    border: 2px solid transparent;
    background-clip: content-box;
  }

  & > div > div:first-child::-webkit-scrollbar-track{
    background: #1a1b20;
    box-shadow:
    inset 1px 0 0 #ffffff,
    inset -1px 0 0 #ffffff;
  }

  & > div > div:first-child::-webkit-scrollbar-button{
    display: none;
    width: 0;
    height: 0;
  }

  & > div > div:first-child > button{
    display: flex; 
    align-items: center; 
    justify-content: center;
    position: relative;
    background-color: #495057;
    border: 1px solid #495057;
    border-radius: 16px;
    cursor: pointer;
    outline: none;
    overflow: hidden;
    font-weight: 400;
    font-size: 18px;
    color: #fff;
    text-shadow: 0px 0px 30px #ffffff;
    transition: transform .2s ease, border-color .2s ease, box-shadow .2s ease;

    &:hover .thumb { opacity: 1; }
    &:hover .label { opacity: 0; }
    
  

    @media (max-width: 426px){
      font-size : 14px;
    }
  }

  & > div > div:first-child > button.active {
    border: 3px solid #BD1236;
 }
  & > div > div:first-child > button.active > img{
    opacity: 1;
  }
  & > div > div:first-child > button.active > span{
    opacity : 0;
  }

  & > div > div:first-child > button > img{
    position: absolute; 
    inset: 0;
    width: 100%; 
    height: 100%;
    object-fit: cover;
    transition: opacity 0.3s ease;
  }
  & > div > div:first-child > button:not(.active) .thumb {
    opacity: 0.5;
}

  & > div > div:first-child > button > span{
    position: relative;
    z-index: 1;
    opacity: 1;
    transition: opacity .18s ease;
  }

  & > div > div:nth-of-type(2){
    background-color: #495057;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    height: 330px;
    grid-area: video;

    iframe { width: 100%; height: 100%; border: 0; border-radius: 12px; }

    @media (max-width: 426px){
    width : 100%;
    height: 184px;
    grid-area: video;
   }

   & > div > div:nth-of-type(2) > div{
    font-size: 18px;
   }

`;

function SubTechniqueSection({ subTechniques = [] }) {
  const [activeVideos, setActiveVideos] = useState([]);
  const [activeCardIndices, setActiveCardIndices] = useState([]);

  useEffect(() => {
    setActiveVideos(
      subTechniques.map(
        (s) => s?.subTechniqueResources?.[0]?.youtubeVideoId || null
      )
    );
    setActiveCardIndices(subTechniques.map(() => 0));
  }, [subTechniques]);

  const handleClick = (sectionIndex, resIndex, youtubeVideoId) => {
    setActiveVideos((prev) => {
      const next = [...prev];
      next[sectionIndex] = youtubeVideoId || null;
      return next;
    });

    setActiveCardIndices((prev) => {
      const next = [...prev];
      next[sectionIndex] = resIndex;
      return next;
    });
  };

  return (
    <main>
      {subTechniques.map((sub, subindex) => {
        const currentVideo = activeVideos[subindex] || null;
        const activeCardIndex = activeCardIndices[subindex];
        const resources = sub?.subTechniqueResources || [];

        return (
          <Section key={`${sub.subTechniqueName}-${subindex}`}>
            <p>{sub.subTechniqueName}</p>
            <p>{sub.subTechniqueDescription}</p>

            <div>
              <div
                className={
                  "card-container" + (resources.length > 4 ? " scrollable" : "")
                }
              >
                {resources.map((res, resindex) => {
                  const raw = res.youtubeVideoId || "";
                  const idOnly = raw.split("?")[0];
                  const isActive = activeCardIndex === resindex;

                  return (
                    <button
                      key={`${res.title}-${resindex}`}
                      className={"card" + (isActive ? " active" : "")}
                      onClick={() => handleClick(subindex, resindex, raw)}
                      title={res.title || "리소스"}
                    >
                      {raw && (
                        <img
                          className="thumb"
                          src={`https://img.youtube.com/vi/${idOnly}/mqdefault.jpg`}
                          alt={res.title || "thumbnail"}
                          loading="lazy"
                        />
                      )}
                      <span className="label">{res.title || ""}</span>
                    </button>
                  );
                })}
              </div>

              <div>
                {currentVideo ? (
                  <iframe
                    src={`https://www.youtube.com/embed/${currentVideo}`}
                    title="Technique Video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  />
                ) : (
                  <div>
                    <img src="/play.png" alt="placeholder" />
                  </div>
                )}
              </div>
            </div>
          </Section>
        );
      })}
    </main>
  );
}

export default SubTechniqueSection;
